// extracted by mini-css-extract-plugin
var _1 = "DisplayError_description__aaa99";
var _2 = "DisplayError_goToPlatform__94137";
var _3 = "DisplayError_link__c538b";
var _4 = "DisplayError_linkText__bcebd";
var _5 = "DisplayError_platformLogo__4ad64";
var _6 = "DisplayError_root__2dfc3";
var _7 = "DisplayError_title__06bf2";
export { _1 as "description", _2 as "goToPlatform", _3 as "link", _4 as "linkText", _5 as "platformLogo", _6 as "root", _7 as "title" }
